import { render } from "./odaPieChart.vue?vue&type=template&id=794f8a18&scoped=true"
import script from "./odaPieChart.vue?vue&type=script&lang=js"
export * from "./odaPieChart.vue?vue&type=script&lang=js"

import "./odaPieChart.vue?vue&type=style&index=0&id=794f8a18&lang=scss&scoped=true"

import exportComponent from "/data/jenkins-workspace/workspace/Publicar_automáticamente_por_Lianxin/联心运营后台前端【生产】/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-794f8a18"]])

export default __exports__